import { render, staticRenderFns } from "./TokenBalanceBlock.vue?vue&type=template&id=6c66323b&scoped=true&"
import script from "./TokenBalanceBlock.vue?vue&type=script&lang=js&"
export * from "./TokenBalanceBlock.vue?vue&type=script&lang=js&"
import style0 from "./TokenBalanceBlock.vue?vue&type=style&index=0&id=6c66323b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c66323b",
  null
  
)

export default component.exports